import { render } from "./modal-sav.vue?vue&type=template&id=7dd66341"
import script from "./modal-sav.vue?vue&type=script&lang=js"
export * from "./modal-sav.vue?vue&type=script&lang=js"

import "./modal-sav.vue?vue&type=style&index=0&id=7dd66341&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__